import { FieldLayout, LabelPosition, LayoutWithLabel } from '@websential/cosmic';
import { FormHelperText, GridSize } from '@mui/material';

import { Calendar } from 'primereact/calendar';
import React from 'react';
import { useController } from 'react-hook-form';

interface IT4DOBCalendar extends LayoutWithLabel {
  name: string;
  onChangeHandler: (date:any) => void;
  format?: string;
  invalidLabel?: string;
  masked?: boolean;
  disabled?: boolean;
  disableFuture?: boolean;
  maxDate?: Date;
  minDate?: Date;
  helperText?: string | any;
  showlabel?: boolean;
  placeholder?: any;
  className?: any;
}

export const T4DOBCalendar: React.FC<IT4DOBCalendar> = ({
  name,
  label,
  showlabel,
  placeholder,
  labelPosition = LabelPosition.Left,
  labelColumns = 4 as GridSize,
  fieldColumns = 8 as GridSize,
  format = 'MMM D, YYYY',
  disabled = false,
  disableFuture = false,
  required = false,
  maxDate = undefined,
  minDate = undefined,
  helperText,
  className,
  onChangeHandler, // custom external handler
}) => {
  const {
    field: { onChange, value },
    formState: { errors },
  } = useController({
    name,
  });

  // ✅ Combine both handlers
  const handleChange = (e: any) => {
    const dateValue = e.value ?? null;
    onChange(dateValue); // updates react-hook-form
    onChangeHandler(e); // triggers custom logic
  };

  return (
    <FieldLayout
      label={label}
      isRequired={required}
      testId={'calendar'}
      labelPosition={labelPosition}
      labelColumns={labelColumns}
      fieldColumns={fieldColumns}
      fieldTopPadding={0.8}
    >
      <Calendar
        id={name}
        value={value || null}
        showIcon
        disabled={disabled}
        className={`${className} w-full calender`}
        style={{ height: '2.6rem', margin: '8px 0px 4px 0px' }}
        onChange={handleChange} // ✅ Combined handler
        dateFormat="M dd, yy"
        placeholder={placeholder}
        required={required}
        maxDate={maxDate}
        minDate={minDate}
      />

      {helperText && (
        <FormHelperText
          sx={{ margin: '4px 14px 0 17px' }}
          error
          role="alert"
        >
          {helperText}
        </FormHelperText>
      )}
    </FieldLayout>
  );
};
